<script setup lang="ts">
import { useGeoDataStore } from '~/stores/geoData'

const props = defineProps<{ afirData: any; areaType: string }>()

const geoDataStore = useGeoDataStore()
await geoDataStore.initCounties()
await geoDataStore.initMunicipalities()

const municipality = computed(() => {
  return (municipalityCode: string) =>
    geoDataStore.municipalities.find(
      (municipality) => municipality.municipality_code === municipalityCode
    )
})

const county = computed(() => {
  return (countyCode: string) =>
    geoDataStore.counties.find((county) => county.county_code === countyCode)
})

const totalElectricVehicleCount = computed(() => {
  return (data: any) => {
    return (
      (data.vehicleTypes?.find((t: any) => t.vehicleType === 'personbil')?.electricVehicleCount ||
        0) +
      (data.vehicleTypes?.find((t: any) => t.vehicleType === 'lätt lastbil')
        ?.electricVehicleCount || 0)
    )
  }
})
const totalPluginHybridVehicleCount = computed(() => {
  return (data: any) => {
    return (
      (data.vehicleTypes?.find((t: any) => t.vehicleType === 'personbil')
        ?.pluginHybridVehicleCount || 0) +
      (data.vehicleTypes?.find((t: any) => t.vehicleType === 'lätt lastbil')
        ?.pluginHybridVehicleCount || 0)
    )
  }
})

const tableData = computed(() => {
  if (!props.afirData) return []
  return props.afirData
    .map((data: any) => {
      const regionGetter = props.areaType === 'municipality' ? municipality : county
      const region = regionGetter.value(data.regionId)
      // console.log(data)
      return {
        regionName: region?.name,
        regionId: data.regionId,
        slug: region?.slug,
        countyCode: region?.county_code,
        totalPower: data.totalPower,
        totalElectricVehicleCount: data.totalElectricVehicleCount,
        totalPluginHybridVehicleCount: data.totalPluginHybridVehicleCount,
        powerPerElectricVehicle: data.powerPerElectricVehicle,
        requiredPower: data.requiredPowerElectricVehicle + data.requiredPowerPluginHybridVehicle,
        isAfirCompliant: data.isAfirCompliant,
        powerDifference:
          data.totalPower -
          (data.requiredPowerElectricVehicle + data.requiredPowerPluginHybridVehicle),
      }
    })
    .sort((a: any, b: any) => {
      return a.regionName.localeCompare(b.regionName)
    })
})
</script>
<template>
  <DataTable :value="tableData">
    <Column field="regionName" :header="areaType === 'municipality' ? 'Kommun' : 'Län'" sortable>
      <template #body="slotProps">
        <span v-if="areaType === 'municipality'">
          <NuxtLink :to="`/utforska-en-plats/kommun/${slotProps.data.slug}`">
            {{ slotProps.data.regionName }}
          </NuxtLink>
        </span>
        <span v-if="areaType === 'county'">
          <NuxtLink :to="`/utforska-en-plats/region/${slotProps.data.slug}`">
            {{ slotProps.data.regionName }}
          </NuxtLink>
        </span>
      </template>
    </Column>
    <Column field="requiredPower" header="Krav AFIR" sortable>
      <template #body="slotProps">
        <span class="data-value">{{ (slotProps.data.requiredPower / 1000).toFixed(2) }} MW</span>
      </template>
    </Column>
    <Column field="totalPower" header="Total effekt" sortable>
      <template #body="slotProps">
        <span class="data-value">{{ (slotProps.data.totalPower / 1000).toFixed(2) }} MW</span>
      </template>
    </Column>
    <Column field="powerDifference" header="Avvikelse" sortable>
      <template #body="slotProps">
        <span
          :class="{
            compliant: slotProps.data.isAfirCompliant,
            'non-compliant': !slotProps.data.isAfirCompliant,
          }"
          class="complicance-value data-value"
        >
          {{ (slotProps.data.powerDifference / 1000).toFixed(2) }} MW</span
        >
      </template>
    </Column>
    <!-- <Column field="totalElectricVehicleCount" header="Elbilar" sortable>
      <template #body="slotProps"> {{ slotProps.data.totalElectricVehicleCount }} st </template>
    </Column> -->
    <!-- <Column field="totalElectricVehicleCount" header="Laddhybrider" sortable>
      <template #body="slotProps"> {{ slotProps.data.totalPluginHybridVehicleCount }} st </template>
    </Column> -->
    <!-- <Column field="powerPerElectricVehicle" header="Laddeffekt per elbil" sortable>
      <template #body="slotProps">
        {{ slotProps.data.powerPerElectricVehicle.toFixed(1) }}
        kW
        <Tag
          v-if="slotProps.data.powerPerElectricVehicle > 1.3"
          value="AFIR"
          class="afir-tag"
          rounded
        ></Tag>
      </template>
    </Column> -->
  </DataTable>
</template>
<style lang="scss" scoped>
.data-value {
  white-space: nowrap;
}
.complicance-value {
  font-weight: 600;
}
.afir-tag {
  background: #2a6236;
  margin-left: 0.5rem;
}
.compliant {
  color: #074d65;
}
.non-compliant {
  color: #E69138;
}
</style>
